module.exports = __webpack_public_path__ + "static/ReelSaga-6a5ec310fd196392625a96f330bb1b81.png";